module.exports = __webpack_public_path__ + "img/youtube.8723b0a7.svg";